module.exports = __webpack_public_path__ + "img/merchant-active.185cd0df.svg";